var React = require('react');

function Flower (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M91.861 94.985c5.039-1.457 9.72-3.864 10.239-8.884.438-4.542-3.738-6.685-7.93-8.22-2.4-.88-5.777-1.141-7.835-2.435-3.213-1.999-2.724-5.716-1.824-8.91 1.65-5.808 4.723-11.262 2.027-16.771-1.038-2.12-3.576-3.817-5.736-5.117-2.972-1.748-6.178-.618-9.052-1.83-6.374-2.676-2.813-8.765-.775-13.268 2.282-5.055 1.17-9.392-4.166-11.473-2.368-.958-6.051-.602-8.082-1.808-2.627-1.545-1.73-4.37-1.188-6.885.583-2.617 1.495-5.89-.849-7.81C54.434-.283 49.634-.246 46.411.41 34.976 2.74 22.043 9.485 13.227 17.05 1.805 26.854-1.348 41.568.487 56.035c1.625 12.843 7 25.77 17.284 33.635 17.196 13.15 44.94 11.5 64.906 7.27 2.493-.508 5.905-1.023 9.184-1.955z"}));
}

Flower.defaultProps = {"viewBox":"0 0 103 100"};

module.exports = Flower;

Flower.default = Flower;
